<template>

  <div class="page-container">
    <div class="settings-form">
      <h2 class="page-title">爆文改写</h2>

      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-input v-model="searchForm.article_title" placeholder="请输入爆文标题" clearable size="large"
          style="width: 300px; margin-right: 15px" @keyup.enter="handleSearch">
          <template #prefix>
            <el-icon>
              <Search />
            </el-icon>
          </template>
        </el-input>

        <el-button type="primary" size="large" @click="handleSearch">
          <el-icon>
            <Search />
          </el-icon>
          搜索
        </el-button>

        <el-button type="success" size="large" @click="openAddDialog" style="float: right">
          <el-icon>
            <Plus />
          </el-icon>
          新增爆文改写
        </el-button>
      </div>

      <!-- 爆文改写列表 -->
      <el-table :data="rewriteList" stripe style="width: 100%; margin-top: 20px" v-loading="loading">
        <el-table-column prop="ghz_url" label="爆文链接" min-width="200" show-overflow-tooltip />
        <el-table-column prop="article_title" label="文章标题" min-width="200" />
        <el-table-column label="分类" width="150">
          <template #default="{ row }">
            {{ getCategoryName(row.article_category_id) }}
          </template>
        </el-table-column>
        <el-table-column label="图库" width="150">
          <template #default="{ row }">
            {{ getGalleryName(row.tuku_id) }}
          </template>
        </el-table-column>
        <el-table-column label="模板样式" width="100">
          <template #default="{ row }">
            模板{{ row.moban_style }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template #default="{ row }">
            <el-tag :type="getStatusTag(row.article_status)">
              {{ getStatusText(row.article_status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" width="180" />
        <el-table-column prop="update_time" label="更新时间" width="180" />

        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button type="danger" size="small" @click="handleDelete(scope.row.id)">
              <el-icon>
                <Delete />
              </el-icon>
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination v-model:current-page="pagination.page" v-model:page-size="pagination.pageSize"
          :total="pagination.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes, prev, pager, next, jumper"
          @size-change="fetchRewriteList" @current-change="fetchRewriteList" />
      </div>
    </div>


    <!-- 新增对话框 -->
    <el-dialog v-model="dialogVisible" title="新增爆文改写" width="720px" :close-on-click-modal="false">
      <el-form ref="rewriteForm" :model="rewriteForm" label-width="140px" :rules="formRules">
        <el-form-item label="文章链接" prop="ghz_url">
          <el-input v-model="rewriteForm.ghz_url" placeholder="请输入爆文链接" size="large">
            <template #append>
              <el-button type="primary" @click="parseArticle" :loading="parsing" :disabled="parsing">
                {{ parsing ? '解析中...' : '立即解析' }}
              </el-button>
            </template>
          </el-input>

        </el-form-item>

        <!-- 智能体接口选项 -->
        <el-form-item label="智能体接口" prop="coze_id">
          <el-select v-model="rewriteForm.coze_id" placeholder="请选择智能体接口" filterable clearable style="width: 100%">
            <!-- 新增固定选项：推文专属解析 -->
            <el-option label="推文专属解析" :value="-1" />
            <el-option v-for="coze in cozeSettings" :key="coze.id" :label="coze.coze_name" :value="coze.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="文章标题" prop="article_title">
          <el-input v-model="rewriteForm.article_title" placeholder="请输入文章标题" size="large" />
        </el-form-item>

        <el-form-item label="文章内容" prop="article_content">
          <RichTextEditor ref="richTextEditor" v-model:content="rewriteForm.article_content" @error="handleEditorError"
            @show-html="showHtmlDialog" />
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="文章分类" prop="article_category_id">
              <el-select v-model="rewriteForm.article_category_id" placeholder="请选择分类" style="width: 100%">
                <el-option v-for="category in categories" :key="category.id" :label="category.article_category"
                  :value="category.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图库" prop="tuku_id">
              <el-select v-model="rewriteForm.tuku_id" placeholder="请选择图库" style="width: 100%">
                <el-option v-for="gallery in galleries" :key="gallery.id" :label="gallery.tuku_name"
                  :value="gallery.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="配图数量" prop="article_tp_num">
              <el-input-number v-model="rewriteForm.article_tp_num" :min="1" :max="10" controls-position="right"
                style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模板样式" prop="moban_style">
              <el-select v-model="rewriteForm.moban_style" placeholder="请选择模板" style="width: 100%">
                <!-- 添加"不选择模板"选项 -->
                <el-option label="不选择模板" :value="0" />
                <el-option v-for="moban in mobanStyles" :key="moban.id" :label="moban.moban_name" :value="moban.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="写作模型" prop="article_write_model_id">
          <el-select v-model="rewriteForm.article_write_model_id" placeholder="请选择写作模型（不选则用默认配置）" style="width: 100%">
            <el-option label="不选择模型" :value="-1" />
            <el-option v-for="model in writingModels.filter(d => d.writing_type === '1')" :key="model.id"
              :label="model.writing_name" :value="model.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="标题模型" prop="article_title_model_id">
          <el-select v-model="rewriteForm.article_title_model_id" placeholder="请选择标题模型（不选则用默认配置）" style="width: 100%">
            <el-option label="不选择模型" :value="-1" />
            <el-option v-for="model in writingModels.filter(d => d.writing_type === '2')" :key="model.id"
              :label="model.writing_name" :value="model.id" />
          </el-select>
        </el-form-item>

        <!-- 新增立即改写按钮 -->
        <el-form-item>
          <el-button type="primary" style="width: 100%;" @click="rewriteTitleAndContent" :loading="rewriting">
            <el-icon>
              <Edit />
            </el-icon>
            立即改写
          </el-button>
        </el-form-item>

        <el-form-item label="文章状态" prop="article_status">
          <el-radio-group v-model="rewriteForm.article_status">
            <el-radio :label="1">待审核</el-radio>
            <el-radio :label="2">正常</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注信息">
          <el-input v-model="rewriteForm.notes" placeholder="请输入备注信息" type="textarea" :rows="3" />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRewriteForm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import config from '@/config.js';
import Cookies from 'js-cookie';
import {
  Search, Plus, Delete, Edit
} from '@element-plus/icons-vue'
import RichTextEditor from '@/components/RichTextEditor.vue';

export default {
  name: 'ArticleRewrite',
  components: { Search, Plus, Delete, RichTextEditor, Edit },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      rewriting: false, // 改写状态
      // 新增：智能体接口列表
      cozeSettings: [],
      searchForm: {
        article_title: ''
      },
      rewriteForm: {
        ghz_url: '',
        article_title: '',
        article_content: '', // 添加文章内容字段
        article_category_id: null,
        tuku_id: null,
        article_tp_num: 1,
        moban_style: 1,
        article_write_model_id: null,
        article_title_model_id: null,
        article_status: 1,
        parsing: false, // 添加解析状态
        pollingInterval: null, // 轮询定时器

        notes: ''
      },
      formRules: {
        ghz_url: [
          { required: true, message: '请输入爆文链接', trigger: 'blur' }
        ],
        article_title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ],
        article_content: [ // 添加文章内容验证规则
          { required: true, message: '请输入文章内容', trigger: 'blur' }
        ],
        article_category_id: [
          { required: true, message: '请选择文章分类', trigger: 'change' }
        ],
        tuku_id: [
          { required: true, message: '请选择图库', trigger: 'change' }
        ],
        coze_id: [ // 添加coze_id验证规则
          { required: true, message: '请选择智能体接口', trigger: 'change' }
        ],
        article_title_model_id: [
          // 非必选，不选时使用 la_config 默认配置
        ],
        article_write_model_id: [
          // 非必选，不选时使用 la_config 默认配置
        ]
      },
      rewriteList: [],
      mobanStyles: [], // 存储从接口获取的模板数据

      categories: [],
      galleries: [],
      writingModels: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    userInfo() {
      return JSON.parse(Cookies.get('user_info') || '{}')
    },

    // 分类映射
    categoryMap() {
      const map = {};
      this.categories.forEach(category => {
        map[category.id] = category.article_category;
      });
      return map;
    },
    // 添加模板映射
    mobanMap() {
      const map = {};
      this.mobanStyles.forEach(moban => {
        map[moban.id] = moban;
      });
      return map;
    },
    // 图库映射
    galleryMap() {
      const map = {};
      this.galleries.forEach(gallery => {
        map[gallery.id] = gallery.tuku_name;
      });
      return map;
    }
  },
  mounted() {
    this.fetchRewriteList();
    this.fetchCategories();
    this.fetchGalleries();
    this.fetchWritingModels();
    this.fetchCozeSettings(); // 新增：获取智能体接口
    this.fetchMobanStyles(); // 新增：获取模板样式


  },
  methods: {
    // 新增：获取模板样式
    async fetchMobanStyles() {
      try {
        const params = {
          action: 'list',
          store_id: this.userInfo.id,
          page: 1,
          page_size: 100 // 获取所有模板
        };

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/moban_manager.php`,
          params
        );

        if (data.data) {
          this.mobanStyles = data.data;

          // 如果有模板数据，默认选择第一个模板
          if (this.mobanStyles.length > 0) {
            this.rewriteForm.moban_style = this.mobanStyles[0].id;
          }
        }
      } catch (error) {
        console.error('获取模板样式错误:', error);
      }
    },
    // 新增方法：处理API错误
    handleApiError(error) {
      console.error('API请求错误:', error);

      // 检查是否为响应错误
      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 401:
            this.$message.error('身份验证失败，请重新登录');
            break;
          case 403:
            this.$message.error('操作权限不足');
            break;
          case 500:
            this.$message.error(`服务器内部错误: ${data.message || '请联系管理员'}`);
            break;
          default:
            this.$message.error(data.error || data.message || '未知错误');
        }
      } else if (error.request) {
        // 请求已发送但无响应
        this.$message.error('服务器响应超时，请稍后再试');
      } else {
        // 其他错误
        this.$message.error(`请求失败: ${error.message}`);
      }
    },
    // 获取状态标签
    getStatusTag(status) {
      switch (status) {
        case 1: return 'info';
        case 2: return 'success';
        case 3: return 'danger';
        default: return '';
      }
    },

    // 获取状态文本
    getStatusText(status) {
      switch (status) {
        case 1: return '待审核';
        case 2: return '正常';
        case 3: return '禁用';
        default: return '未知';
      }
    },

    // 显示HTML代码弹窗
    showHtmlDialog(html) {
      this.$prompt('HTML代码', '查看HTML源码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValue: html,
        customClass: 'html-code-dialog',
        inputAttributes: {
          rows: 10,
          style: 'width: 100%; font-family: monospace;'
        }
      }).then(() => { }).catch(() => { });
    },

    // 改写标题和内容（通过后端API，自动扣点+记录消费日志）
    async rewriteTitleAndContent() {
      if (!this.rewriteForm.article_title || !this.rewriteForm.article_content) {
        this.$message.error('请先填写文章标题和内容');
        return;
      }

      try {
        this.rewriting = true;

        const userInfo = JSON.parse(Cookies.get('user_info') || '{}');
        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/article_rewrite_api.php`,
          {
            action: 'rewrite',
            store_id: userInfo.id,
            article_title: this.rewriteForm.article_title,
            article_content: this.rewriteForm.article_content,
            article_write_model_id: this.rewriteForm.article_write_model_id,
            article_title_model_id: this.rewriteForm.article_title_model_id,
            moban_style: this.rewriteForm.moban_style
          }
        );

        if (data.success) {
          this.rewriteForm.article_title = data.data.new_title;
          this.rewriteForm.article_content = data.data.new_content;

          if (this.$refs.richTextEditor) {
            this.$refs.richTextEditor.setContent(data.data.new_content);
          }

          this.$message.success('文章改写完成！');
        } else {
          this.$message.error(data.error || '改写失败');
        }
      } catch (error) {
        console.error('文章改写失败:', error);
        const errorMsg = error.response?.data?.error || error.message || '操作失败';
        this.$message.error(`文章改写失败: ${errorMsg}`);
      } finally {
        this.rewriting = false;
      }
    },
    async parseArticle() {
      // 验证必填项
      if (!this.rewriteForm.ghz_url) {
        this.$message.error('请先输入爆文链接');
        return;
      }

      // 处理推文专属解析的特殊情况
      if (this.rewriteForm.coze_id === -1) {
        await this.parseTwitterArticle();
        return;
      }

      // 验证智能体接口选择
      if (!this.rewriteForm.coze_id) {
        this.$message.error('请选择智能体接口');
        return;
      }

      // 防止重复点击
      if (this.parsing) return;

      // 获取选中的智能体接口配置
      const selectedCoze = this.cozeSettings.find(item => item.id === this.rewriteForm.coze_id);
      if (!selectedCoze) {
        this.$message.error('未找到选中的智能体配置');
        return;
      }

      // 显示加载提示
      let messageInstance = this.$message({
        message: '正在解析文章，请稍候...',
        type: 'info',
        duration: 0,
        icon: 'el-icon-loading',
        customClass: 'message-loading-custom'
      });

      try {
        this.parsing = true;
        // 调用后端解析接口
        const response = await axios.post(
          `${config.BASE_URL}/shop/api/ParseArticleController.php`,
          {
            action: 'parse',
            store_id: this.userInfo.id,
            ghz_url: this.rewriteForm.ghz_url,
            coze_url: selectedCoze.coze_url,
            coze_access_token: selectedCoze.coze_access_token,
            coze_botid: selectedCoze.coze_botid
          }
        );

        if (response.data.success) {
          // 填充解析结果
          this.rewriteForm.article_title = response.data.data.title;
          this.rewriteForm.article_content = response.data.data.content;

          // 更新富文本编辑器内容
          setTimeout(() => {
            if (this.$refs.richTextEditor) {
              this.$refs.richTextEditor.setContent(this.rewriteForm.article_content);
            }
          }, 100);

          this.$message.success('解析成功！');
        } else {
          throw new Error(response.data.error || '未知错误');
        }
      } catch (error) {
        console.error('解析文章出错:', error);
        this.handleApiError(error);
      } finally {
        this.parsing = false;
        messageInstance.close(); // 关闭消息提示
      }
    },

    // 新增：解析推文内容的方法
    async parseTwitterArticle() {
      // 防止重复点击
      if (this.parsing) return;

      // 显示加载提示
      let messageInstance = this.$message({
        message: '正在解析推文，请稍候...',
        type: 'info',
        duration: 0,
        icon: 'el-icon-loading',
        customClass: 'message-loading-custom'
      });

      try {
        this.parsing = true;

        // 直接调用推文解析API
        const response = await axios.post(
          'https://gzh.aijzdi.com/tw_jx_api.php',
          { url: this.rewriteForm.ghz_url },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          }
        );

        // 处理响应
        if (response.data.status === "success") {
          this.rewriteForm.article_title = response.data.title || "推文解析";
          this.rewriteForm.article_content = response.data.content_html || response.data.content;

          // 更新富文本编辑器内容
          setTimeout(() => {
            if (this.$refs.richTextEditor) {
              this.$refs.richTextEditor.setContent(this.rewriteForm.article_content);
            }
          }, 100);

          this.$message.success('推文解析成功！');
        } else {
          throw new Error(response.data.message || '推文解析失败');
        }
      } catch (error) {
        console.error('解析推文失败:', error);
        let errorMessage = '推文解析失败';

        if (error.response) {
          const { status, data } = error.response;
          errorMessage += ` (HTTP ${status})`;

          if (data && data.error) {
            errorMessage += `: ${data.error}`;
          }
        } else if (error.message) {
          errorMessage += `: ${error.message}`;
        }

        this.$message.error(errorMessage);
      } finally {
        this.parsing = false;
        messageInstance.close(); // 关闭消息提示
      }
    },

    // 处理富文本编辑器错误
    handleEditorError(message) {
      this.$message.error(message);
    },


    // 获取分类名称
    getCategoryName(id) {
      return this.categoryMap[id] || '未知分类';
    },

    // 获取图库名称
    getGalleryName(id) {
      return this.galleryMap[id] || '未知图库';
    },

    // 获取爆文改写列表
    async fetchRewriteList() {
      this.loading = true;
      try {
        const params = {
          action: this.searchForm.article_title ? 'search' : 'list',
          store_id: this.userInfo.id,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        };

        // 如果有搜索条件，加入搜索参数
        if (this.searchForm.article_title) {
          params.article_title = this.searchForm.article_title;
        }

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/article_hot_create_management.php`,
          params
        );

        if (data.data) {
          this.rewriteList = data.data;
          this.pagination.total = data.pagination?.total || data.data.length;
        }
      } catch (error) {
        this.$message.error('获取爆文改写列表失败');
        console.error('获取爆文改写列表错误:', error);
      } finally {
        this.loading = false;
      }
    },

    // 获取分类列表
    async fetchCategories() {
      try {
        const params = {
          action: 'list_all',
          store_id: this.userInfo.id,
          page: 1,
          page_size: 100
        };

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/article_category_management.php`,
          params
        );

        if (data.data) {
          this.categories = data.data;
        }
      } catch (error) {
        console.error('获取分类列表错误:', error);
      }
    },

    // 获取图库列表
    async fetchGalleries() {
      try {
        const params = {
          action: 'list',
          store_id: this.userInfo.id,
          page: 1,
          page_size: 100
        };

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/library_management.php`,
          params
        );

        if (data.data) {
          this.galleries = data.data;
        }
      } catch (error) {
        console.error('获取图库列表错误:', error);
      }
    },

    // 获取写作模型列表
    async fetchWritingModels() {
      try {
        const params = {
          action: 'list',
          store_id: this.userInfo.id,
          page: 1,
          page_size: 100
        };

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/WritingModelKeyController.php`,
          params
        );

        if (data.data) {
          this.writingModels = data.data;
        }
      } catch (error) {
        console.error('获取写作模型列表错误:', error);
      }
    },

    // 处理搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchRewriteList();
    },

    // 新增：获取智能体接口列表
    async fetchCozeSettings() {
      try {
        const userInfo = JSON.parse(Cookies.get('user_info') || '{}');
        const params = {
          action: 'list',
          store_id: userInfo.id,
          page: 1,
          page_size: 100 // 获取所有
        };

        const { data } = await axios.post(
          `${config.BASE_URL}/shop/api/CozeSettingsController.php`,
          params
        );

        if (data.data) {
          this.cozeSettings = data.data;
        }
      } catch (error) {
        console.error('获取智能体接口失败:', error);
      }
    },

    // 打开新增对话框
    openAddDialog() {
      this.rewriteForm = {
        ghz_url: '',
        article_title: '',
        article_content: '', // 初始化文章内容
        article_category_id: null,
        tuku_id: null,
        article_tp_num: 1,
        moban_style: 0, // 默认设置为0，表示不选择任何模板
        article_write_model_id: null,
        article_title_model_id: null,
        article_status: 2,
        coze_id: null, // 初始化coze_id
        notes: ''
      };

      // 添加关键代码：延迟确保编辑器内容重置
      setTimeout(() => {
        // 显式触发内容更新
        if (this.$refs.richTextEditor) {
          this.$refs.richTextEditor.clearContent(); // 调用富文本编辑器组件的清空方法
        }
      }, 100);
      this.dialogVisible = true;
    },

    // 提交表单（新增）
    submitRewriteForm() {
      this.$refs.rewriteForm.validate(async (valid) => {
        if (valid) {
          try {
            const payload = {
              ...this.rewriteForm,
              store_id: this.userInfo.id
            };

            const { data } = await axios.post(
              `${config.BASE_URL}/shop/api/article_hot_create_management.php`,
              {
                action: 'add',
                ...payload
              }
            );

            if (data.success) {
              this.$message.success('添加成功');
              this.dialogVisible = false;
              this.fetchRewriteList();
            } else {
              this.$message.error(data.error || '操作失败');
            }
          } catch (error) {
            const errorMsg = error.response?.data?.error || error.message || '操作失败';
            this.$message.error(`操作失败: ${errorMsg}`);
            console.error('表单提交错误:', error);
          }
        }
      });
    },

    // 删除记录
    async handleDelete(id) {
      this.$confirm('确定要删除该爆文改写记录吗？', '警告', {
        confirmButtonText: '确认删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const { data } = await axios.post(
            `${config.BASE_URL}/shop/api/article_hot_create_management.php`,
            {
              action: 'delete',
              id: id,
              store_id: this.userInfo.id
            }
          );

          if (data.success) {
            this.$message.success('删除成功');
            this.fetchRewriteList();
          } else {
            this.$message.error(data.error || '删除失败');
          }
        } catch (error) {
          const errorMsg = error.response?.data?.error || error.message || '删除失败';
          this.$message.error(`删除失败: ${errorMsg}`);
          console.error('删除错误:', error);
        }
      }).catch(() => { });
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles/page-common.scss' as *;
</style>